import { FC, Fragment, ReactNode, forwardRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type ImageModalPreviewProps = {
  imageModalOpen: boolean;
  handleClose: () => void;
  title: string;
  children: ReactNode;
};

const ImageModalPreview: FC<ImageModalPreviewProps> = ({
  imageModalOpen,
  handleClose,
  children,
  title,
}) => {
  return (
    <Fragment>
      <Dialog
        open={imageModalOpen}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-full bg-blue-500 p-2 px-4 flex items-center justify-between">
          <h1 className="text-white text-2xl">{title}</h1>
          <IconButton onClick={() => handleClose()}>
            <CloseIcon className="text-white" />
          </IconButton>
        </div>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </Fragment>
  );
};
export default ImageModalPreview;
